import API from 'api';
import _ from 'lodash';
import * as C from './constants';
import receiveNetworkException from './network';
import error from './error';
import * as FeedbackModels from './models/feedbacks';

export const loadSuccess = (type, res) => ({
  type,
  ...res,
});

export const load = (params) => (dispatch) => {
  dispatch({ type: C.LOAD_FEEDBACKS });
  return API.feedbacks.load({ ...params, fields: 'spot,image' })
    .then(({ body: { data, included, meta } }) => {
      if (!_.isEmpty(params.group_by)) {
        return {
          data: FeedbackModels.GroupedFeedbacksList(data),
          meta,
        };
      }

      return {
        data: FeedbackModels.FeedbacksList(data, included),
        meta,
      };
    })
    .then((res) => dispatch(loadSuccess(C.LOAD_FEEDBACKS_SUCCESS, res)))
    .catch((e) => {
      dispatch(receiveNetworkException(e));
      return dispatch(error(C.LOAD_FEEDBACKS_ERROR, 'Error loading feedbacks'));
    });
};

export const loadPhotos = (params, page = 1) => (dispatch) => {
  dispatch({ type: C.LOAD_FEEDBACKS_PHOTOS });
  const fields = 'spot,answers';
  const PAGE_SIZE = 5;
  return API.feedbacks.load(
    { ...params, fields, page: { number: page, size: PAGE_SIZE } },
  )
    .then(({ body: { data, meta } }) => ({
      data: FeedbackModels.FeedbacksList(data),
      meta,
      page,
    }))
    .then((res) => dispatch(loadSuccess(C.LOAD_FEEDBACKS_PHOTOS_SUCCESS, res)))
    .catch((e) => {
      dispatch(receiveNetworkException(e));
      return dispatch(error(C.LOAD_FEEDBACKS_PHOTOS_ERROR, 'Error loading feedbacks'));
    });
};

export const loadMap = (params) => (dispatch) => {
  dispatch({ type: C.LOAD_FEEDBACKS_MAP });
  return API.feedbacks.load({ ...params, fields: 'spot,image', page: {} })
    .then(({ body: { data, included, meta } }) => ({
      data: FeedbackModels.FeedbacksList(data, included),
      meta,
    }))
    .then((res) => dispatch(loadSuccess(C.LOAD_FEEDBACKS_MAP_SUCCESS, res)))
    .catch((e) => {
      dispatch(receiveNetworkException(e));
      return dispatch(error(C.LOAD_FEEDBACKS_MAP_ERROR, 'Error loading feedbacks'));
    });
};

export const loadAllMap = (params) => (dispatch) => {
  dispatch({ type: C.LOAD_ALL_FEEDBACKS_MAP });
  return API.feedbacks.loadAll({ ...params, fields: 'spot,image', page: {} })
    .then(({ body: { data, included, meta } }) => ({
      data: FeedbackModels.FeedbacksList(data, included),
      meta,
    }))
    .then((res) => dispatch(loadSuccess(C.LOAD_ALL_FEEDBACKS_MAP_SUCCESS, res)))
    .catch((e) => {
      dispatch(receiveNetworkException(e));
      return dispatch(error(C.LOAD_ALL_FEEDBACKS_MAP_ERROR, 'Error loading feedbacks'));
    });
};

export const get = (feedbackId) => (dispatch) => {
  dispatch({ type: C.LOAD_FEEDBACK });
  return API.feedbacks.get(feedbackId)
    .then(({ body: { data, included, meta } }) => ({
      data: FeedbackModels.Feedback({ data, included }),
      meta,
    }))
    .then((res) => dispatch(loadSuccess(C.LOAD_FEEDBACK_SUCCESS, res)))
    .catch((e) => {
      dispatch(receiveNetworkException(e));
      return dispatch(error(C.LOAD_FEEDBACK_ERROR, 'Error loading feedback'));
    });
};
